import React, { Component } from 'react';
import Button from '../ui/button';
import * as style from './schedule.module.scss';

class Schedule extends Component {
	constructor(props) {
		super(props);
		this.state = {
			width: 0,
			activeDay: 1,
			activeProgram: 0
		};
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}
	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}
	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}
	updateWindowDimensions() {
		this.setState({ width: window.innerWidth });
	}
	setActiveDay(dayNum) {
		return;
	}
	setActiveProgram(programNum, dayNum) {
		return;
	}

	convertTitle(title) {
		return (title ?? '').replace(/[^\w\s]/gi, '').replace(/\s/g,'');
	}

	render() {
		const width = (this.state) ? this.state.width: 0;

		let activeDay = this.state.activeDay;
		let activeProgram = this.state.activeProgram;

		let scheduleLength = this.props.schedule?.length ?? 0;

		var componentRef = this;

		return (
			<div id="schedule-wrap">
				<h1 className={`${style.scheduleTitle} schedule-title`}>Program Schedule</h1>
				<div id="schedule-wrap-inset">
					<div
						id="schedule-programs"
						className={`${style.schedulePrograms} schedule-programs`}
					>
						{this.props.schedule?.length > 0 && this.props.schedule.map(function(item, i) {
							var dayIndex = parseInt(1 + i);

							var dayClass = '';
							if (activeDay == dayIndex) {
								dayClass = 'active';
							}

							var lastDayClass = '';
							if (dayIndex == scheduleLength) {
								lastDayClass = 'last-day';
							}

							return (
								<div
									className={`${style.scheduleDayPrograms} `+dayClass+` `+lastDayClass+` schedule-day-programs day-`+(dayIndex)}
								>
									{item.programs?.length > 0 && item.programs.map(function(program, i) {
										var programIndex = parseInt(1 + i);

										var programClass = '';
										if (activeProgram == programIndex) {
											programClass = 'active';
										}
										var lastClass = '';
										if (programIndex == (item.programs?.length ?? 0)) {
											lastClass = 'last';
										}

										return (
											<div
												className={`${style.program} program `+programClass+` `+lastClass+` program-`+(programIndex)+` day-`+(dayIndex)+` program-`+(dayIndex)+'-'+(programIndex)}
											>
												<div
													className={`${style.programHeader} program-header`}
													onClick={() => componentRef.setActiveProgram(programIndex, dayIndex)}
												>
													{programIndex == 1 && item.day_title &&
														<div className='program-day-title'>
															{item.day_title}
														</div>
													}
													{program.time &&
														<div className='program-time'>
															{program.time}
														</div>
													}

													{program.youtube_video_id &&
														<div
															className={`${style.programVideo} program-video`}
															id={componentRef.convertTitle(program.title)}
														>
															<div className="video-container">
																<iframe
																src={`https://www.youtube-nocookie.com/embed/${program.youtube_video_id}?enablejsapi=1&modestbranding=1&rel=0&iv_load_policy=3`}
																referrerPolicy="strict-origin-when-cross-origin"
																allowFullScreen
																frameBorder="0"
																allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">
																</iframe>
															</div>
														</div>
													}

													<div className='program-title'>
														{program.title}
													</div>
												</div>

												{
													<div className={`${style.programMeta} program-meta`}>
														{program.description &&
															<div className={`${style.programDescription} program-description`}>
																{program.description}
															</div>
														}

														<div className={`${style.programSpeakers} program-speakers`}>
															{program.speakers?.length > 0 && program.speakers.map(function(speaker, i) {
																return (
																	<div className={`${style.programSpeaker} program-speaker`}>
																		<div
																			className={`${style.speakerImage} speaker-image`}
																			style={{ backgroundImage: 'url('+(speaker?.bio_image ?? '')+')'}}
																		>
																		</div>

																		<div className={`${style.speakerMeta} speaker-meta`}>
																			<div className={`${style.speakerName} speaker-name`}>
																				{speaker.name}
																			</div>
																			<div className={`${style.speakerPosition} speaker-position`}>
																				{speaker.position}
																			</div>
																		</div>
																	</div>
																);
															})}
														</div>
													</div>
												}
											</div>
										);
									})}
								</div>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
};

export default Schedule;
